import adminApi from './adminApi';
import { API_ENDPOINTS, debugApiCall } from './apiRegistry';

export const divisionsAPI = {
  // Get all divisions
  getAll: (params = {}) => {
    debugApiCall(API_ENDPOINTS.DIVISIONS.LIST, params);
    return adminApi.get(API_ENDPOINTS.DIVISIONS.LIST, { params });
  },

  // Get single division
  getById: (id) => {
    debugApiCall(API_ENDPOINTS.DIVISIONS.GET(id));
    return adminApi.get(API_ENDPOINTS.DIVISIONS.GET(id));
  },

  // Create division
  create: (data) => {
    debugApiCall(API_ENDPOINTS.DIVISIONS.CREATE, data);
    return adminApi.post(API_ENDPOINTS.DIVISIONS.CREATE, data);
  },

  // Update division
  update: (id, data) => {
    debugApiCall(API_ENDPOINTS.DIVISIONS.UPDATE(id), data);
    return adminApi.put(API_ENDPOINTS.DIVISIONS.UPDATE(id), data);
  },

  // Delete division
  delete: (id) => {
    debugApiCall(API_ENDPOINTS.DIVISIONS.DELETE(id));
    return adminApi.delete(API_ENDPOINTS.DIVISIONS.DELETE(id));
  },

  // Assign teams to divisions
  assignTeams: () => {
    debugApiCall(API_ENDPOINTS.DIVISIONS.ASSIGN_TEAMS);
    return adminApi.post(API_ENDPOINTS.DIVISIONS.ASSIGN_TEAMS);
  }
};
